<template>
    <div class="video-js-responsive-containerx vjs-hdx video-border vjs-16-9"> 
        <video ref="videoPlayer" autoplay class="video-js" crossorigin="anonymous" rel="vilala">
            <source type="application/x-mpegURL">
        </video>
    </div>
</template>

<script>

import videojs from 'video.js';
import youtube from 'videojs-youtube';
import hls  from 'videojs-contrib-hls';

require('../../resolution-switcher')


export default {
    name: "videoPlayer",
    
    props: {
        poster: { type: String, required: false },
        sources: {
            type: Array,
            default() {
                return [];
            }
        },
        next_url: { type: String, required: false },
        content_type: { type: String, default: 'hls' }
    },

    data(){
        return {
            player: null,
            playerOptions:{
                muted: false,
                autoplay: true,
                language: 'en',
                fluid: true,
                responsive: true,
                techOrder: ['html5'],
                playbackRates: [0.5, 1, 1.5, 2],
                preload: "metadata",
                sources: [],
                poster: "",
                controls: true,
                youtube: {
                    ytControls: 2,
                    customVars: { 
                        wmode: 'transparent' 
                    }
                },
                html5: { hls: { withCredentials: false }},
                plugins:{
                    videoJsResolutionSwitcher: {
                        default: 'high',
                        dynamicLabel: true
                    }
                }
            }
        }
    },

    methods: {
      playerReadied(videoPlayer) {
        var hls = videoPlayer.tech({ IWillNotUseThisInPlugins: true }).hls
        videoPlayer.tech_.hls.xhr.beforeRequest = function(options) {
          return options
        }
      }
    },


    beforeMount(){
       // this.playerOptions.poster = "https://test-transload.s3-us-east-2.amazonaws.com/2b/07dc8328424e54b9252db17572b314/phpC7C7.jpg"; //this.poster
        this.playerOptions.poster = this.poster;
        this.playerOptions.sources = this.sources;
        //console.log(this);
    },

    async mounted() {
        this.player = await videojs(this.$refs.videoPlayer, this.playerOptions, function onPlayerReady() {
            //console.log('ready')
            //this.player.play()
        }).on('ended', () => {
            if(this.next_url){
                setTimeout(() => {
                    window.location.href= this.next_url
                }, 2000)
            }
        })

        this.$bus.$on('video:stop', () => {
            if(this.player){
                this.player.dispose()
            }
        })
    },

    beforeDestroy() {
        if (this.player) {
            this.player.dispose()
        }
    }

}

</script>
<style>
    .video-border{
        border: 1px solid #6c757d85;
    }

    .vjs-resolution-button .vjs-resolution-button:before {
        content: '\f110';
        font-family: VideoJS;
        font-weight: normal;
        font-style: normal;
        font-size: 1.8em;
        line-height: 1.67em;
    }

    /* .vjs-resolution-button .vjs-resolution-button-label {
        font-size: 1em;
        line-height: 3em;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        text-align: center;
        box-sizing: inherit;
    }  */

    /* 
    .vjs-resolution-button .vjs-menu .vjs-menu-content {
        width: 4em;
        left: 50%;
        margin-left: -2em; 
    }

    .vjs-resolution-button .vjs-menu li {
        text-transform: none;
        font-size: 1em;
    } */
</style>
